import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "overflow-auto",
  style: {"min-height":"295px"}
}
const _hoisted_2 = { class: "panel-title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "font-size-12-600 text-uppercase" }
const _hoisted_6 = { class: "font-black" }

import {ref, watch} from 'vue';
import Icon from "@/components/Icons/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderDetailsDialog',
  props: {
  modelValue: [String, Number],

  attributes: {
    type: Array,
    default: () => []
  },

  isSupplier: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props

const dialog = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
  dialog.value = newValue;
});

watch(dialog, (newValue) => {
  emit('update:modelValue', newValue);
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog).value = $event)),
    "max-width": "400",
    "min-width": "30%",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "font-grey-dark" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h6 d-flex justify-space-between align-center" }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createTextVNode(" Product Details ", -1)),
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
              }, [
                _createVNode(Icon, {
                  color: "grey_light",
                  icon: "cross-icon"
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_1, [
            (__props.isSupplier)
              ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                  key: 0,
                  variant: "accordion"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.attributes, (itemInfo, index) => {
                      return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                        key: `itemInfo-${index}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_expansion_panel_title, null, {
                            actions: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                class: "panel-arrow",
                                icon: "fa-chevron-down"
                              })
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_2, _toDisplayString(itemInfo.title ?? itemInfo.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_expansion_panel_text, null, {
                            default: _withCtx(() => [
                              (itemInfo.content)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "my-2 text-subtitle-1",
                                    innerHTML: itemInfo.content
                                  }, null, 8, _hoisted_3))
                                : _createCommentVNode("", true),
                              (itemInfo.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "my-2 text-subtitle-1",
                                    innerHTML: itemInfo.value
                                  }, null, 8, _hoisted_4))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_card, {
                  key: 1,
                  class: "font-grey-dark",
                  variant: "text"
                }, {
                  text: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.attributes, (attribute, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `description-${index}`,
                        class: _normalizeClass({'pt-4': index > 0})
                      }, [
                        _createElementVNode("p", _hoisted_5, _toDisplayString(attribute.name), 1),
                        _createElementVNode("p", _hoisted_6, _toDisplayString(attribute.value), 1)
                      ], 2))
                    }), 128))
                  ]),
                  _: 1
                }))
          ]),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                class: "b-round-20 outline-btn cancel",
                elevation: "0",
                height: "32px",
                "x-small": "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (dialog.value = false))
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Cancel ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})